import { RecordOf } from '@opengov/compose-app/immutable';

export interface IReportConfigurationPermalink {
  id: string;
  reportConfigurationId: string;
  reportId: string;
  urls: {
    public: string;
    private: string;
    publicPermalink?: string;
    privatePermalink?: string;
  };
  createdAt: string;
  createdBy: string;
}

export interface IReportConfigurationPermalinkPayload {
  reportConfigurationId: string;
  reportId: string;
  urls: {
    public: string;
    private: string;
    publicPermalink?: string;
    privatePermalink?: string;
  };
  createdBy: string;
}

export const ReportConfigurationPermalinkPayload = RecordOf<IReportConfigurationPermalinkPayload>({
  reportConfigurationId: null,
  reportId: null,
  urls: {
    public: null,
    private: null
  },
  createdBy: null
});

export const ReportConfigurationPermalink = RecordOf<IReportConfigurationPermalink>({
  id: null,
  reportId: null,
  reportConfigurationId: null,
  urls: {
    public: null,
    private: null
  },
  createdAt: null,
  createdBy: null
});
